module.exports = __webpack_public_path__ + "60d2a425eefb68ad5a22637dcd23172b.svg";